module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-11-5de0bbb4de0d60329fb5440e61d2a2e6.jpeg";